import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// Importar módulos de rotas
import authRoutes from './modules/auth'
import dashboardRoutes from './modules/dashboard'
import apiRoutes from './modules/api'
import architectureRoutes from './modules/architecture'
import docsRoutes from './modules/docs'

// Combinar todas as rotas dos módulos
const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...apiRoutes,
  ...architectureRoutes,
  ...docsRoutes
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Importar guards
import { authGuard } from './guards/auth'

// Aplicar guards de navegação
router.beforeEach(authGuard)

export default router
